var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 34H32",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26H24",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 5V6C26 11.6569 26 14.4853 27.7574 16.2426C29.5148 18 32.3432 18 38 18H39M40 21.3138V28C40 35.5424 40 39.3138 37.6568 41.6568C35.3138 44 31.5424 44 24 44C16.4575 44 12.6863 44 10.3431 41.6568C8 39.3138 8 35.5424 8 28V18.9117C8 12.4216 8 9.17662 9.77214 6.97866C10.1302 6.53462 10.5346 6.13016 10.9787 5.77214C13.1766 4 16.4216 4 22.9116 4C24.3228 4 25.0282 4 25.6744 4.22802C25.8088 4.27544 25.9404 4.33 26.069 4.3915C26.6872 4.6871 27.186 5.186 28.1838 6.18376L37.6568 15.6569C38.813 16.813 39.391 17.391 39.6956 18.1261C40 18.8612 40 19.6787 40 21.3138Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.12ad7a704ee0188b0138d4a66cad8058.svg";
export { ForwardRef as ReactComponent };